module.exports = __webpack_public_path__ + "img/sld_vcb_green_ta1_ba1.a74acf8f.svg";